import { render } from "./LeaderboardTable.vue?vue&type=template&id=9f2f4762&scoped=true"
import script from "./LeaderboardTable.vue?vue&type=script&lang=js"
export * from "./LeaderboardTable.vue?vue&type=script&lang=js"

import "./LeaderboardTable.vue?vue&type=style&index=0&id=9f2f4762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f2f4762"]])

export default __exports__